import $ from 'jquery';
import {disableBodyScroll, enableBodyScroll} from 'body-scroll-lock';
import Accordion from '../ui/accordion';
import MegaMenu from '../ui/mega-menu';

const namespace = 'navigation';

export default class Navigation {
  query = window.matchMedia('(min-width: 50em)');
  accordionInstance = null;

  constructor(el, options) {
    this.options = $.extend(
      true,
      {
        selectors: {
          trigger: '.js-nav-trigger',
          close: '.js-nav-close',
        },
        classes: {
          active: 'is-active',
        },
      },
      options,
    );

    this.$el = $(el);
    this.el = this.$el.get(0);
    this.$triggers = $(this.options.selectors.trigger);

    this.bind();
    this.check(this.query);
  }

  /**
   * Apply event listeners
   */
  bind() {
    $(this.options.selectors.trigger).on(
      `click.trigger.${namespace}`,
      this.open.bind(this),
    );

    this.$el.on(
      `click.close.${namespace}`,
      this.options.selectors.close,
      this.close.bind(this),
    );

    this.query.addListener(this.check.bind(this));
  }

  /**
   * @param {Event|MediaQueryList} media
   */
  check(media) {
    if (!media.matches) {
      this.accordionInstance = this.setup();
      this.destroyMenu();
      return;
    }

    this.menuInstance = this.setupMenu();
    this.teardown();
  }

  open() {
    disableBodyScroll(this.el);
    this.$el.addClass(this.options.classes.active);
  }

  close() {
    enableBodyScroll(this.el);
    this.$el.removeClass(this.options.classes.active);
  }

  /**
   * @returns {Accordion}
   */
  setup() {
    return new Accordion('.megamenu__container', {
      selectors: {
        item: '.megamenu__item',
        anchor: '.megamenu__link',
        list: '.megamenu__dropdown',
      },
    });
  }

  teardown() {
    if (this.accordionInstance) {
      this.accordionInstance.destroy();
    }

    this.$el.removeClass(this.options.classes.active);
    enableBodyScroll(this.el);
  }

  /**
   * @returns {MegaMenu}
   */
  setupMenu() {
    return new MegaMenu(this.el);
  }

  destroyMenu() {
    if (this.menuInstance) {
      this.menuInstance.destroy();
    }
  }
}
